import {
    REPORT_GET_SALE_REPORT_ACTION,
    REPORT_GET_SALE_REPORT_SUCCESS,
    REPORT_GET_SALE_REPORT_BY_ORDER_ACTION,
    REPORT_GET_SALE_REPORT_BY_ORDER_SUCCESS,
    REPORT_GET_SALE_REPORT_BY_SKU_ACTION,
    REPORT_GET_SALE_REPORT_BY_SKU_SUCCESS,
    REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION,
    REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_SUCCESS,
    REPORT_VOUCHER_REDEEMTION_ACTION,
    REPORT_VOUCHER_REDEEMTION_SUCCESS,
    REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION,
    REPORT_VOUCHER_REDEEMTION_DETAIL_SUCCESS,
    REPORT_EXPORT_REDEEMTIONS_ACTION,
    REPORT_EXPORT_REDEEMTIONS_FAIL,
    REPORT_EXPORT_REDEEMTIONS_SUCCESS,
    REPORT_GET_CASH_FLOW_REPORT_ACTION,
    REPORT_GET_CASH_FLOW_REPORT_SUCCESS,
    REPORT_FAIL,
    REPORT_GET_COLLABORATOR_REPORT_SUCCESS,
    REPORT_GET_COLLABORATOR_REPORT_ACTION,
    CROSS_CHECK_ACTION,
    CROSS_CHECK_SUCCESS,
    DEFAULT_CROSS_CHECK_STATUS,
    REPORT_EXPORT_COLLABORATOR_REPORT_ACTION,
    REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS,
    REPORT_EXPORT_COLLABORATOR_REPORT_FAIL,
    REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION,
    REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_SUCCESS,

    REPORT_GET_BTB_ORDER_REPORT_ACTION,
    REPORT_GET_BTB_ORDER_REPORT_SUCCESS,
    REPORT_EXPORT_BTB_ORDER_REPORT_ACTION,
    REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS,
    REPORT_EXPORT_BTB_ORDER_REPORT_FAIL,
    REPORT_GET_BTB_USE_ROOM_REPORT_ACTION,
    REPORT_GET_BTB_USE_ROOM_REPORT_SUCCESS,
    REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION,
    REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS,
    REPORT_EXPORT_BTB_USE_ROOM_REPORT_FAIL,
} from '../constants/Types';
import SaleReport from '../models/SaleReport';
import SaleReportByOrder from '../models/SaleReportByOrder';
import SaleReportBySKU from '../models/SaleReportBySKU';
import SaleDetailReportBySKU from '../models/SaleDetailReportBySKU';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
import { findIndex } from 'lodash';
import ReportCollaborator from '../models/ReportCollaborator';
import ReportBtbUseRoom from '../models/ReportBtbUseRoom';
import SaleDetailReportByHotel from 'models/SaleDetailReportByHotel';
import ReportBtbOrder from '../models/ReportBtbOrder';


const initialState = {
    isFetching: false,
    isFetched: false,
    isFetchingDownload: false,
    saleReport: new SaleReport(),
    saleReportByOrder: new SaleReportByOrder(),
    saleReportBySKU: new SaleReportBySKU(),
    saleDetailReportBySKU: new SaleDetailReportBySKU(),
    saleDetailReportByHotel: new SaleDetailReportByHotel(),
    cashFlowReport: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
        totalPage: 0,
        startDate: moment.utc().startOf('isoWeeks'),
        endDate: moment.utc().endOf('days'),
        orderBy: undefined,
        orderByDesc: false,
        cashFlows: [],
    },
    voucherRedeemReport: {
        pageSize: PAGINATION.pageSize,
        pageIndex: PAGINATION.pageIndex,
        totalCount: PAGINATION.totalCount,
        totalPage: 0,
        startDate: moment.utc().startOf('isoWeeks'),
        endDate: moment.utc().endOf('days'),
        orderBy: undefined,
        orderByDesc: false,
        loadingGroup: undefined,
        voucherRedeemtions: [],
    },
    isCrossCheckStatus: null,
    isFetchingCollaborator: true,
    collaboratorReport: new ReportCollaborator(),
    isFetchingCrossCheck: false,
    isFetchingExportCollaborator: false,
  
    isFetchingBtbOrder: true,
    isFetchingExportBtbOrder: false,
    btbOrderReport: new ReportBtbOrder(),
  
    isFetchingBtbUseRoom: true,
    isFetchingExportBtbUseRoom: false,
    btbUseRoomReport: new ReportBtbUseRoom(),
};

export default (state = initialState, action) => {
    switch (action.type) {
        case REPORT_GET_SALE_REPORT_ACTION:
            return { ...state, isFetching: true };
        case REPORT_GET_SALE_REPORT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                saleReport: action.saleReport,
            };
        case REPORT_GET_SALE_REPORT_BY_ORDER_ACTION:
            return { ...state, isFetching: true };
        case REPORT_GET_SALE_REPORT_BY_ORDER_SUCCESS:
            return {
                ...state,
                isFetching: false,
                saleReportByOrder: action.saleReportByOrder,
            };
        case REPORT_GET_SALE_REPORT_BY_SKU_ACTION:
            return { ...state, isFetching: true };
        case REPORT_GET_SALE_REPORT_BY_SKU_SUCCESS:
            return {
                ...state,
                isFetching: false,
                saleReportBySKU: action.saleReportBySKU,
            };
        case REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION:
            return { ...state, isFetching: true };
        case REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_SUCCESS:
            return {
                ...state,
                isFetching: false,
                saleDetailReportBySKU: action.saleReportBySKU,
            };
        case REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION:
            return { ...state, isFetching: true };
        case REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                saleDetailReportByHotel: action.saleReportByHotel,
            };
        case REPORT_VOUCHER_REDEEMTION_ACTION:
            return { ...state, isFetching: true };
        case REPORT_VOUCHER_REDEEMTION_SUCCESS:
            return {
                ...state,
                isFetching: false,
                voucherRedeemReport: {
                    ...action.params,
                    totalPage: Math.ceil(parseInt(action.params.totalCount || 0) / parseInt(action.params.pageSize || 0)),
                    voucherRedeemtions: action.voucherRedeemtions,
                },
            };
        case REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION:
            return { ...state, voucherRedeemReport: { ...state.voucherRedeemReport, loadingGroup: action.params.groupId } };
        case REPORT_VOUCHER_REDEEMTION_DETAIL_SUCCESS:
            const voucherRedeemtions = state.voucherRedeemReport.voucherRedeemtions;
            const detailIndex = findIndex(voucherRedeemtions, item => item.groupId === action.params.groupId);
            if (detailIndex >= 0) voucherRedeemtions[detailIndex].setDetail({ ...action.params, items: action.items });
            return {
                ...state,
                isFetching: false,
                voucherRedeemReport: {
                    ...state.voucherRedeemReport,
                    loadingGroup: undefined,
                    voucherRedeemtions,
                },
            };
        case REPORT_GET_CASH_FLOW_REPORT_ACTION:
            return { ...state, isFetchingDownload: true }
        case REPORT_GET_CASH_FLOW_REPORT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                cashFlowReport: {
                    ...action.params,
                    totalPage: Math.ceil(parseInt(action.params.totalCount || 0) / parseInt(action.params.pageSize || 0)),
                    cashFlows: action.cashFlow,
                },
            };
        case REPORT_EXPORT_REDEEMTIONS_ACTION:
            return { ...state, isFetchingDownload: true }
        case REPORT_EXPORT_REDEEMTIONS_FAIL:
            return { ...state, isFetchingDownload: false }
        case REPORT_EXPORT_REDEEMTIONS_SUCCESS:
            return { ...state, isFetchingDownload: false }
        case REPORT_GET_COLLABORATOR_REPORT_ACTION:
            return {...state, isFetchingCollaborator: true}
        case REPORT_GET_COLLABORATOR_REPORT_SUCCESS:
            return {...state, isFetchingCollaborator: false, collaboratorReport: action.reports}
        case REPORT_EXPORT_COLLABORATOR_REPORT_ACTION:
            return {...state, isFetchingExportCollaborator: true}
        case REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS:
            return {...state, isFetchingExportCollaborator: false}
        case REPORT_EXPORT_COLLABORATOR_REPORT_FAIL:
            return {...state, isFetchingExportCollaborator: false}
        case CROSS_CHECK_ACTION:
            return {...state, isFetchingCrossCheck: true}
        case CROSS_CHECK_SUCCESS:
            return {...state, isFetchingCrossCheck: false, isCrossCheckStatus: action.reports.isSuccess}
        case REPORT_FAIL:
            return { ...state, isFetching: false, voucherRedeemReport: { ...state.voucherRedeemReport, loadingGroup: undefined } };
        case DEFAULT_CROSS_CHECK_STATUS:
            return {...state, isCrossCheckStatus: null};
        case REPORT_GET_BTB_ORDER_REPORT_ACTION:
            return {...state, isFetchingBtbOrder: true}
        case REPORT_GET_BTB_ORDER_REPORT_SUCCESS:
            return {...state, isFetchingBtbOrder: false, btbOrderReport: action.reports}
        case REPORT_EXPORT_BTB_ORDER_REPORT_ACTION:
            return {...state, isFetchingExportBtbOrder: true}
        case REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS:
            return {...state, isFetchingExportBtbOrder: false}
        case REPORT_EXPORT_BTB_ORDER_REPORT_FAIL:
            return {...state, isFetchingExportBtbOrder: false}
        case REPORT_GET_BTB_USE_ROOM_REPORT_ACTION:
            return {...state, isFetchingBtbUseRoom: true}
        case REPORT_GET_BTB_USE_ROOM_REPORT_SUCCESS:
            return {...state, isFetchingBtbUseRoom: false, btbUseRoomReport: action.reports}
        case REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION:
            return {...state, isFetchingExportBtbUseRoom: true}
        case REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS:
            return {...state, isFetchingExportBtbUseRoom: false}
        case REPORT_EXPORT_BTB_USE_ROOM_REPORT_FAIL:
            return {...state, isFetchingExportBtbUseRoom: false}
        default:
            return state;
    }
}
